import React from "react";
import { CContainer } from "@coreui/react-pro";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <CContainer
        lg
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <ul>
          <li>
            <a
              href="https://support.infraview.app"
              target="_blank"
            >
              {t("common.support")}
            </a>
          </li>
          <li>|</li>
          <li>
            <a
              href="https://support.infraview.app/hc/en-us/articles/9274501993357-Privacy-Policy"
              target="_blank"
            >
              {t("pages.userAcceptance.privacyPolicy")}
            </a>
          </li>
          <li>|</li>
          <li>
            <a
              href="https://support.infraview.app/hc/en-us/articles/9274525345037-Terms-of-Service"
              target="_blank"
            >
              {t("pages.userAcceptance.termsOfService")}
            </a>
          </li>
          <li>|</li>
          <li>
            <a
              href="https://support.infraview.app/hc/en-us/articles/20462395247373-Software-License-Attributions-for-InfraView"
              target="_blank"
            >
              {t("pages.userAcceptance.attributions")}
            </a>
          </li>
        </ul>
        <p>
          © {new Date().getFullYear()} InfraSight Software Corporation, All
          Rights Reserved.
        </p>
      </CContainer>
    </footer>
  );
};
export default React.memo(Footer);
